import { LIST_PAGINATED_TASKS_COLUMNS } from 'domain/models';
import { TableColumn } from 'react-data-table-component';

interface IProps {
  name: string;
}

export const makeColumnsTask = (): TableColumn<IProps>[] => {
  return [
    {
      name: 'Tarefa',
      selector: (row) => row.name,
      sortable: true,
      sortField: LIST_PAGINATED_TASKS_COLUMNS.NAME,
    },
  ];
};
